import { useMemo } from "react";

import type { ScreenMembersOnResetPasswordEmail } from "@auth0/auth0-acul-js";
import ResetPasswordEmailInstance from "@auth0/auth0-acul-js/reset-password-email";

import { executeSafely } from "../utils/helpers/executeSafely";

export const useResetPasswordEmailManager = () => {
  const resetPasswordEmailInstance = useMemo(
    () => new ResetPasswordEmailInstance(),
    []
  );

  const { screen, transaction } = resetPasswordEmailInstance;
  const { texts, data } = screen;

  const handleResendEmail = async (): Promise<void> => {
    executeSafely("ResetPasswordEmail resend email", () =>
      resetPasswordEmailInstance.resendEmail()
    );
  };

  return {
    resetPasswordEmailInstance,
    handleResendEmail,
    texts: (texts || {}) as ScreenMembersOnResetPasswordEmail["texts"],
    errors: resetPasswordEmailInstance.getError(),
    loginLink: screen.links?.login || null,
    transactionState: transaction.state || "",
    prefilledIdentifier: data?.username || "",
  };
};
